import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSnykComponent } from './simple-icons-snyk.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSnykComponent ],
    exports:      [ SimpleIconsSnykComponent ],
    bootstrap:    []
})
export class SimpleIconsSnykModule {}
